import { Alert, AlertTitle, Box, Button, Divider, Typography } from "@mui/material";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import { PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";

function ErrorScreen({ resetErrorBoundary }: any) {
  return <Box display="flex" justifyContent="center" alignItems="center" minWidth="100%">
    <Alert severity="error" sx={{maxWidth: 600, margin: "5em"}}>
      <AlertTitle>Something went wrong</AlertTitle>
      <Typography>We're sorry for the inconvenience. The problem has been recorded and will be investigated.</Typography>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Button variant="contained" onClick={resetErrorBoundary}>Home</Button>
    </Alert>
  </Box>
}

export default function ErrorBoundary({ children }: PropsWithChildren) {
  const navigate = useNavigate();

  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorScreen}
      onReset={() => navigate("/")}
    >
      {children}
    </ReactErrorBoundary>
  );
}
